import { Component, Input, OnInit } from '@angular/core';
import { CustomerCareBookingData, CustomerCareBookingStatus } from '../../services/customer-care.service';

@Component({
    selector: 'app-pg-customer-care-booking',
    templateUrl: './pg-customer-care-booking.component.html',
    styleUrls: ['./pg-customer-care-booking.component.scss'],
    standalone: false
})
export class PgCustomerCareBookingComponent implements OnInit {

    @Input() bookingData:CustomerCareBookingData = null;

    constructor() { }

    ngOnInit(): void {    
    }

    getStatusColor(status:CustomerCareBookingStatus) {
        switch (status) {
            case 'available': return 'secondary';
            case 'pending': return 'secondary';
            case 'confirmed': return 'primary';
            case 'canceled': return 'danger';
        }
    }
}
